(function () {
  if (window.ERSProductPageEnhancements) return;

  var instances = [];
  var recommendationInstances = [];

  function numberAttribute(element, name, fallback) {
    var value = Number(element && element.getAttribute(name));
    return Number.isFinite(value) && value > 0 ? value : fallback;
  }

  function RelatedCarousel(carousel, signal) {
    if (!carousel || carousel._ersRelatedCarousel) return carousel && carousel._ersRelatedCarousel;
    this.carousel = carousel;
    this.signal = signal;
    this.resizeFrame = null;
    this.scrollFrame = null;
    carousel._ersRelatedCarousel = this;
    this.init();
  }

  RelatedCarousel.prototype.listen = function (target, type, handler, options) {
    if (!target) return;
    var listenerOptions = options || {};
    listenerOptions.signal = this.signal;
    target.addEventListener(type, handler, listenerOptions);
  };

  RelatedCarousel.prototype.step = function () {
    if (window.innerWidth >= 990) return 4;
    if (window.innerWidth >= 640) return 2;
    return 1;
  };

  RelatedCarousel.prototype.update = function () {
    var viewport = this.carousel.querySelector('[data-product-related-viewport]');
    var previous = this.carousel.querySelector('[data-product-related-prev]');
    var next = this.carousel.querySelector('[data-product-related-next]');
    if (!viewport || !previous || !next) return;
    var maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
    var isStatic = maxScroll <= 2;
    this.carousel.classList.toggle('is-static', isStatic);
    previous.disabled = isStatic || viewport.scrollLeft <= 2;
    next.disabled = isStatic || viewport.scrollLeft >= maxScroll - 2;
    if (this.carousel.hasAttribute('data-carousel-hide-edges')) {
      // Keep the existing arrow gutters stable while removing unusable controls.
      if ((previous.disabled && document.activeElement === previous) || (next.disabled && document.activeElement === next)) {
        viewport.focus({ preventScroll: true });
      }
      previous.hidden = previous.disabled;
      next.hidden = next.disabled;
    }
  };

  RelatedCarousel.prototype.scroll = function (direction) {
    var viewport = this.carousel.querySelector('[data-product-related-viewport]');
    var card = this.carousel.querySelector('[data-product-related-card], .product-related-carousel__card');
    var track = this.carousel.querySelector('[data-product-related-track]');
    if (!viewport || !card || !track) return;
    var gap = parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap) || 0;
    var cardWidth = card.getBoundingClientRect().width + gap;
    var fitRegularRow = this.carousel.closest('[data-regular-pdp]') && this.carousel.closest('[data-regular-role="related"]');
    var step = this.carousel.closest('.equipment-product-information') || fitRegularRow
      ? Math.max(1, Math.floor((viewport.clientWidth + gap) / cardWidth))
      : this.step();
    var distance = cardWidth * step * direction;
    viewport.scrollBy({
      left: distance,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
    });
  };

  RelatedCarousel.prototype.init = function () {
    var self = this;
    var viewport = this.carousel.querySelector('[data-product-related-viewport]');
    var previous = this.carousel.querySelector('[data-product-related-prev]');
    var next = this.carousel.querySelector('[data-product-related-next]');
    this.listen(previous, 'click', function () { self.scroll(-1); });
    this.listen(next, 'click', function () { self.scroll(1); });
    this.listen(viewport, 'keydown', function (event) {
      if (event.target !== viewport) return;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        self.scroll(event.key === 'ArrowLeft' ? -1 : 1);
      } else if (event.key === 'Home' || event.key === 'End') {
        event.preventDefault();
        viewport.scrollTo({ left: event.key === 'Home' ? 0 : viewport.scrollWidth, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
    });
    this.listen(viewport, 'scroll', function () {
      if (self.scrollFrame) return;
      self.scrollFrame = window.requestAnimationFrame(function () {
        self.scrollFrame = null;
        self.update();
      });
    }, { passive: true });
    this.listen(window, 'resize', function () {
      if (self.resizeFrame) window.cancelAnimationFrame(self.resizeFrame);
      self.resizeFrame = window.requestAnimationFrame(function () {
        self.resizeFrame = null;
        self.update();
      });
    });
    if ('ResizeObserver' in window && viewport) {
      this.resizeObserver = new ResizeObserver(function () { self.update(); });
      this.resizeObserver.observe(viewport);
    }
    window.requestAnimationFrame(function () { self.update(); });
  };

  RelatedCarousel.prototype.destroy = function () {
    if (this.resizeObserver) this.resizeObserver.disconnect();
    if (this.resizeFrame) window.cancelAnimationFrame(this.resizeFrame);
    if (this.scrollFrame) window.cancelAnimationFrame(this.scrollFrame);
    this.carousel._ersRelatedCarousel = null;
  };

  function initializeRelatedCarousel(scope, signal) {
    var carousel = scope && scope.matches && scope.matches('[data-product-related-carousel]')
      ? scope
      : scope && scope.querySelector && scope.querySelector('[data-product-related-carousel]');
    if (!carousel) return null;
    return carousel._ersRelatedCarousel || new RelatedCarousel(carousel, signal);
  }

  function productUrlWithinCollection(value, collectionUrl) {
    var productUrl = new URL(value, window.location.origin);
    var productMarker = '/products/';
    var productMarkerIndex = productUrl.pathname.indexOf(productMarker);
    if (productMarkerIndex === -1) return value;

    var productHandle = productUrl.pathname.slice(productMarkerIndex + productMarker.length);
    if (!productHandle || productHandle.indexOf('/') !== -1) return value;

    var contextualUrl = new URL(collectionUrl, window.location.origin);
    contextualUrl.pathname = contextualUrl.pathname.replace(/\/$/, '') + productMarker + productHandle;
    contextualUrl.search = productUrl.search;
    contextualUrl.hash = productUrl.hash;
    return contextualUrl.pathname + contextualUrl.search + contextualUrl.hash;
  }

  function preserveRecommendationCollection(recommendations, collectionUrl) {
    if (!recommendations || !collectionUrl) return;
    recommendations.querySelectorAll('a[href], [data-product-url]').forEach(function (element) {
      if (element.hasAttribute('href')) {
        element.setAttribute('href', productUrlWithinCollection(element.getAttribute('href'), collectionUrl));
      }
      if (element.hasAttribute('data-product-url')) {
        element.setAttribute('data-product-url', productUrlWithinCollection(element.getAttribute('data-product-url'), collectionUrl));
      }
    });
  }

  function ProductRecommendations(root) {
    if (!root || root._ersProductRecommendations) return root && root._ersProductRecommendations;
    this.root = root;
    this.abortController = new AbortController();
    this.signal = this.abortController.signal;
    this.carousel = null;
    root._ersProductRecommendations = this;
    this.load();
  }

  ProductRecommendations.prototype.load = function () {
    var self = this;
    var url = this.root.getAttribute('data-product-recommendations-url');
    if (!url) return;

    fetch(url, {
      credentials: 'same-origin',
      headers: { 'Accept': 'text/html' },
      signal: this.signal
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Product recommendations request failed');
        return response.text();
      })
      .then(function (html) {
        if (self.signal.aborted || !document.documentElement.contains(self.root)) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var recommendations = doc.querySelector('[data-product-recommendations]');
        if (!recommendations) return;
        preserveRecommendationCollection(recommendations, self.root.getAttribute('data-product-recommendations-collection-url'));
        self.root.removeAttribute('data-product-recommendations-url');
        self.root.innerHTML = recommendations.innerHTML;
        self.carousel = initializeRelatedCarousel(self.root, self.signal);
      })
      .catch(function (error) {
        if (error && error.name === 'AbortError') return;
      });
  };

  ProductRecommendations.prototype.destroy = function () {
    this.abortController.abort();
    if (this.carousel) this.carousel.destroy();
    this.root._ersProductRecommendations = null;
  };

  function ProductPage(root) {
    if (!root || root._ersProductPage) return root && root._ersProductPage;
    this.root = root;
    this.abortController = new AbortController();
    this.signal = this.abortController.signal;
    this.viewerOpen = false;
    this.viewerReturnFocus = null;
    this.previousBodyOverflow = '';
    this.previousBodyPaddingRight = '';
    this.touchStart = null;
    this.resizeFrame = null;
    this.scrollFrame = null;
    root._ersProductPage = this;
    this.init();
  }

  ProductPage.prototype.init = function () {
    this.initAccordions();
    this.initShippingMessage();
    this.initQuantity();
    this.initGallery();
    this.initHoverZoom();
    this.initViewer();
    if (this.root.hasAttribute('data-equipment-pdp')) this.initSakPresentation();
    this.carousels = Array.prototype.map.call(this.root.querySelectorAll('[data-product-related-carousel]'), function (carousel) { return initializeRelatedCarousel(carousel, this.signal); }, this);
  };

  ProductPage.prototype.listen = function (target, type, handler, options) {
    if (!target) return;
    var listenerOptions = options || {};
    listenerOptions.signal = this.signal;
    target.addEventListener(type, handler, listenerOptions);
  };

  ProductPage.prototype.initAccordions = function () {
    var self = this;
    this.root.querySelectorAll('[data-product-accordion-button]').forEach(function (button) {
      self.listen(button, 'click', function () {
        var panel = self.root.querySelector('#' + button.getAttribute('aria-controls'));
        if (!panel) return;
        var expanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!expanded));
        panel.hidden = expanded;
      });
    });
  };

  ProductPage.prototype.quantityRulesFromOption = function (variantId) {
    var selector = this.root.hasAttribute('data-regular-pdp') ? 'select[name="id"][id^="productSelect-"]' : '[id^="productSelect-"]';
    var select = this.root.querySelector(selector);
    var option = null;
    if (select) {
      option = Array.prototype.find.call(select.options, function (item) {
        return String(item.value) === String(variantId || select.value);
      });
    }

    var quantity = this.root.querySelector('[data-product-quantity]');
    var source = option || quantity;
    var maxValue = source && source.getAttribute('data-quantity-max');
    return {
      min: numberAttribute(source, 'data-quantity-min', 1),
      increment: numberAttribute(source, 'data-quantity-increment', 1),
      max: maxValue === null || maxValue === '' ? null : Number(maxValue),
      available: option ? option.getAttribute('data-variant-available') !== 'false' : true
    };
  };

  ProductPage.prototype.normalizeQuantity = function (value, rules) {
    var quantity = Number(value);
    if (!Number.isFinite(quantity)) quantity = rules.min;
    quantity = Math.max(rules.min, quantity);
    var steps = Math.floor(((quantity - rules.min) / rules.increment) + 0.000001);
    quantity = rules.min + Math.max(0, steps) * rules.increment;
    if (rules.max !== null && Number.isFinite(rules.max)) {
      var maxSteps = Math.floor(((rules.max - rules.min) / rules.increment) + 0.000001);
      quantity = Math.min(quantity, rules.min + Math.max(0, maxSteps) * rules.increment);
    }
    return quantity;
  };

  ProductPage.prototype.applyQuantityRules = function (variantId, available) {
    var quantity = this.root.querySelector('[data-product-quantity]');
    if (!quantity) return;
    var input = quantity.querySelector('[data-product-quantity-input]');
    var buttons = quantity.querySelectorAll('button');
    if (!input) return;

    var rules = this.quantityRulesFromOption(variantId);
    if (typeof available === 'boolean') rules.available = available;
    quantity.setAttribute('data-quantity-min', rules.min);
    quantity.setAttribute('data-quantity-increment', rules.increment);
    input.min = rules.min;
    input.step = rules.increment;

    if (rules.max !== null && Number.isFinite(rules.max)) {
      quantity.setAttribute('data-quantity-max', rules.max);
      input.max = rules.max;
    } else {
      quantity.removeAttribute('data-quantity-max');
      input.removeAttribute('max');
    }

    input.value = rules.min;
    input.disabled = !rules.available;
    buttons.forEach(function (button) { button.disabled = !rules.available; });
    this.updateQuantityButtonStates();
  };

  ProductPage.prototype.currentQuantityRules = function () {
    var quantity = this.root.querySelector('[data-product-quantity]');
    var maxValue = quantity && quantity.getAttribute('data-quantity-max');
    return {
      min: numberAttribute(quantity, 'data-quantity-min', 1),
      increment: numberAttribute(quantity, 'data-quantity-increment', 1),
      max: maxValue === null || maxValue === '' ? null : Number(maxValue)
    };
  };

  ProductPage.prototype.updateQuantityButtonStates = function () {
    var quantity = this.root.querySelector('[data-product-quantity]');
    if (!quantity) return;
    var input = quantity.querySelector('[data-product-quantity-input]');
    var minus = quantity.querySelector('[data-product-quantity-minus]');
    var plus = quantity.querySelector('[data-product-quantity-plus]');
    var rules = this.currentQuantityRules();
    var value = this.normalizeQuantity(input.value, rules);
    if (minus) minus.disabled = input.disabled || value <= rules.min;
    if (plus) plus.disabled = input.disabled || (rules.max !== null && value + rules.increment > rules.max);
  };

  ProductPage.prototype.initShippingMessage = function () {
    var message = this.root.querySelector('[data-product-shipping-message]');
    if (!message) return;
    this.listen(this.root, 'product:variant:change', function (event) {
      message.style.display = event.detail.available ? '' : 'none';
    });
  };

  ProductPage.prototype.initQuantity = function () {
    var self = this;
    var quantity = this.root.querySelector('[data-product-quantity]');
    if (!quantity) return;
    var input = quantity.querySelector('[data-product-quantity-input]');
    if (!input) return;

    this.listen(quantity, 'click', function (event) {
      var minus = event.target.closest('[data-product-quantity-minus]');
      var plus = event.target.closest('[data-product-quantity-plus]');
      if (!minus && !plus) return;
      event.preventDefault();
      if ((minus || plus).disabled) return;
      var rules = self.currentQuantityRules();
      var value = self.normalizeQuantity(input.value, rules);
      input.value = self.normalizeQuantity(value + (plus ? rules.increment : -rules.increment), rules);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    this.listen(input, 'input', function () { self.updateQuantityButtonStates(); });
    this.listen(input, 'change', function () {
      input.value = self.normalizeQuantity(input.value, self.currentQuantityRules());
      self.updateQuantityButtonStates();
    });
    this.listen(input, 'blur', function () {
      input.value = self.normalizeQuantity(input.value, self.currentQuantityRules());
      self.updateQuantityButtonStates();
    });
    this.listen(this.root, 'product:variant:change', function (event) {
      self.applyQuantityRules(event.detail.variantId, event.detail.available);
    });

    var select = this.root.querySelector('[id^="productSelect-"]');
    this.applyQuantityRules(select && select.value, !input.disabled);
  };

  ProductPage.prototype.activeImageId = function () {
    var active = this.root.querySelector('.product-photo-thumb.is-active');
    if (active) return String(active.getAttribute('data-image-id'));
    var visible = this.root.querySelector('[id^="productPhotoWrapper-"]:not(.hide)');
    return visible ? String(visible.getAttribute('data-image-id')) : '';
  };

  ProductPage.prototype.changeGalleryImage = function (direction) {
    var thumbs = Array.prototype.slice.call(this.root.querySelectorAll('.product-photo-thumb'));
    if (thumbs.length < 2) return;
    var activeId = this.activeImageId();
    var index = thumbs.findIndex(function (thumb) {
      return String(thumb.getAttribute('data-image-id')) === activeId;
    });
    if (index < 0) index = 0;
    var nextIndex = Math.max(0, Math.min(thumbs.length - 1, index + direction));
    if (nextIndex !== index) thumbs[nextIndex].click();
  };

  ProductPage.prototype.initHoverZoom = function () {
    var stage = this.root.querySelector('.product-gallery-stage');
    if (!stage || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    var lens = document.createElement('div');
    lens.className = 'product-hover-zoom';
    lens.setAttribute('aria-hidden', 'true');
    stage.appendChild(lens);
    var activeImage = null;
    var loadedSource = '';
    var pendingSource = '';
    var sourceWidth = 0;
    var sourceHeight = 0;
    var frame = 0;
    var pointer = null;

    function reset() {
      if (frame) window.cancelAnimationFrame(frame);
      frame = 0;
      pointer = null;
      activeImage = null;
      lens.style.display = 'none';
    }

    function schedulePaint() {
      if (!frame) frame = window.requestAnimationFrame(paint);
    }

    function paint() {
      frame = 0;
      if (!pointer || !activeImage || loadedSource !== activeImage.getAttribute('data-product-hover-zoom-src')) return;
      var imageRect = activeImage.getBoundingClientRect();
      var stageRect = stage.getBoundingClientRect();
      var naturalWidth = Number(activeImage.getAttribute('width'));
      var naturalHeight = Number(activeImage.getAttribute('height'));
      if (!naturalWidth || !naturalHeight || !imageRect.width || !imageRect.height) return;
      var fit = Math.min(imageRect.width / naturalWidth, imageRect.height / naturalHeight);
      var width = naturalWidth * fit;
      var height = naturalHeight * fit;
      var left = imageRect.left + (imageRect.width - width) / 2;
      var top = imageRect.top + (imageRect.height - height) / 2;
      var x = (pointer.x - left) / width;
      var y = (pointer.y - top) / height;
      var scale = Math.min(2, sourceWidth / width, sourceHeight / height);
      if (x < 0 || x > 1 || y < 0 || y > 1 || scale <= 1.05) {
        lens.style.display = 'none';
        return;
      }
      lens.style.left = (left - stageRect.left) + 'px';
      lens.style.top = (top - stageRect.top) + 'px';
      lens.style.width = width + 'px';
      lens.style.height = height + 'px';
      lens.style.backgroundSize = (width * scale) + 'px ' + (height * scale) + 'px';
      lens.style.backgroundPosition = (x * 100) + '% ' + (y * 100) + '%';
      lens.style.display = 'block';
    }

    this.listen(stage, 'pointermove', function (event) {
      if (event.pointerType !== 'mouse' || event.target.closest('button, a, video, iframe')) { reset(); return; }
      var image = stage.querySelector('.lazyload__image-wrapper:not(.hide) img[data-product-hover-zoom-src]:not([data-zoom])');
      if (!image) { reset(); return; }
      var source = image.getAttribute('data-product-hover-zoom-src');
      if (activeImage !== image) lens.style.display = 'none';
      activeImage = image;
      pointer = { x: event.clientX, y: event.clientY };
      if (loadedSource === source) { schedulePaint(); return; }
      if (pendingSource === source) return;
      pendingSource = source;
      var zoomImage = new Image();
      zoomImage.onload = function () {
        if (pendingSource !== source) return;
        pendingSource = '';
        if (!activeImage || activeImage.getAttribute('data-product-hover-zoom-src') !== source) return;
        loadedSource = source;
        sourceWidth = zoomImage.naturalWidth;
        sourceHeight = zoomImage.naturalHeight;
        lens.style.backgroundImage = 'url("' + source.replace(/["\\]/g, '\\$&') + '")';
        schedulePaint();
      };
      zoomImage.onerror = function () { if (pendingSource === source) pendingSource = ''; };
      zoomImage.src = source;
    });
    this.listen(stage, 'pointerleave', reset);
    this.listen(this.root, 'product:image:change', reset);
    this.listen(window, 'resize', reset);
    this.hoverZoom = lens;
    this.resetHoverZoom = reset;
  };

  ProductPage.prototype.initGallery = function () {
    var self = this;
    var stage = this.root.querySelector('.product-gallery-stage');
    if (!stage) return;

    this.listen(this.root, 'product:image:change', function (event) {
      var imageId = String(event.detail.imageId);
      var expand = self.root.querySelector('[data-product-image-expand]');
      if (expand) {
        expand.setAttribute('data-image-id', imageId);
        expand.hidden = /^(external-|video-)/.test(imageId);
      }
      self.syncViewer(imageId);
      var activeThumb = self.root.querySelector('.product-photo-thumb[data-image-id="' + imageId + '"]');
      if (activeThumb && activeThumb.scrollIntoView) {
        activeThumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
    });

    this.listen(stage, 'touchstart', function (event) {
      if (event.touches.length !== 1 || event.target.closest('button, a')) return;
      self.touchStart = { x: event.touches[0].clientX, y: event.touches[0].clientY, horizontal: false };
    }, { passive: true });

    this.listen(stage, 'touchmove', function (event) {
      if (!self.touchStart || event.touches.length !== 1) return;
      var dx = event.touches[0].clientX - self.touchStart.x;
      var dy = event.touches[0].clientY - self.touchStart.y;
      if (Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy) * 1.2) {
        self.touchStart.horizontal = true;
        event.preventDefault();
      }
    }, { passive: false });

    this.listen(stage, 'touchend', function (event) {
      if (!self.touchStart || !event.changedTouches.length) return;
      var dx = event.changedTouches[0].clientX - self.touchStart.x;
      var dy = event.changedTouches[0].clientY - self.touchStart.y;
      if (self.touchStart.horizontal && Math.abs(dx) >= 48 && Math.abs(dx) > Math.abs(dy) * 1.2) {
        self.changeGalleryImage(dx < 0 ? 1 : -1);
      }
      self.touchStart = null;
    }, { passive: true });

    this.listen(stage, 'touchcancel', function () { self.touchStart = null; }, { passive: true });

    this.root.querySelectorAll('[data-sak-gallery-step]').forEach(function (button) {
      self.listen(button, 'click', function () {
        var thumbs = Array.prototype.slice.call(self.root.querySelectorAll('.product-photo-thumb'));
        var current = thumbs.findIndex(function (thumb) { return thumb.classList.contains('is-active'); });
        var next = (current + Number(button.getAttribute('data-sak-gallery-step')) + thumbs.length) % thumbs.length;
        if (thumbs[next]) thumbs[next].click();
      });
    });
  };

  // Shared equipment controls; configuration is server-rendered product navigation.
  // Gallery and viewer methods continue to own media state and focus management.
  ProductPage.prototype.initSakPresentation = function () {
    this.root.dispatchEvent(new CustomEvent('equipment:initialize', {detail: {controller: this}}));
    this.initEquipmentQuote();
  };

  ProductPage.prototype.initEquipmentQuote = function () {
    var self = this;
    var form = this.root.querySelector('[data-equipment-quote-form], [data-equipment-purchase-form]');
    var identityNode = this.root.querySelector('[data-equipment-identity]');
    if (!form || !identityNode) return;
    var identity;
    try { identity = JSON.parse(identityNode.textContent); } catch (error) { return; }
    if (!identity.variantId || identity.state === 'impossible') return;
    var quantity = form.querySelector('[data-product-quantity-input]');
    var dialog = this.root.querySelector('[data-equipment-selection-dialog]');
    var returnFocus;
    var activeList;
    var lists = {};
    var storageKey = function (kind) { return 'ers_equipment_' + kind + '_v1'; };
    ['quote', 'compare'].forEach(function (kind) {
      try {
        var saved = JSON.parse(sessionStorage.getItem(storageKey(kind)) || '[]');
        lists[kind] = Array.isArray(saved) ? saved.filter(function (item) {
          return item && typeof item.title === 'string' && typeof item.url === 'string' &&
            Number.isSafeInteger(item.quantity) && item.quantity >= 1 && Array.isArray(item.options) && Array.isArray(item.specs);
        }).map(function (item) {
          // Retain prior session lists. Unkeyed historical specs cannot be
          // asserted equivalent to semantic specs, even with the same label.
          item.specs = item.specs.map(function (spec) { return Array.isArray(spec) ? {key: 'legacy:' + spec[0], label: spec[0], value: spec[1]} : spec; }).filter(function (spec) { return spec && typeof spec.key === 'string' && typeof spec.label === 'string'; });
          return item;
        }) : [];
      } catch (error) { lists[kind] = []; }
    });
    var save = function (kind) {
      try { sessionStorage.setItem(storageKey(kind), JSON.stringify(lists[kind])); } catch (error) { /* The current page still owns the list when storage is unavailable. */ }
    };
    var normalize = function () {
      quantity.value = self.normalizeQuantity(quantity.value, self.currentQuantityRules());
      return Number(quantity.value);
    };
    this.listen(form, 'submit', function () { normalize(); });
    var snapshot = function () {
      return {
        key: identity.key, productId: identity.productId, variantId: identity.variantId,
        title: identity.title, sku: identity.sku, url: identity.url, quantity: normalize(),
        options: identity.configuration.map(function (option) { return [option.label, option.value]; }),
        specs: identity.specs
      };
    };
    var cell = function (row, tag, text) {
      var node = document.createElement(tag);
      node.textContent = text;
      row.appendChild(node);
      return node;
    };
    var renderList = function () {
      var items = lists[activeList];
      var isQuote = activeList === 'quote';
      dialog.querySelector('[data-equipment-selection-title]').textContent = isQuote ? 'Your Quote List' : 'Compare Equipment';
      dialog.querySelector('[data-equipment-selection-intro]').textContent = isQuote
        ? 'Review the products and quantities before requesting your quote.'
        : 'Compare published product specifications. Add another equipment product to this list to compare it alongside this unit.';
      var content = dialog.querySelector('[data-equipment-selection-content]');
      content.replaceChildren();
      var table = document.createElement('table');
      var head = table.createTHead().insertRow();
      cell(head, 'th', isQuote ? 'Requested items' : 'Specifications');
      items.forEach(function (item, index) {
        var heading = cell(head, 'th', item.title);
        heading.scope = 'col';
        if (!isQuote) cell(heading, 'div', [item.sku].concat(item.options.map(function (pair) { return pair.join(': '); })).filter(Boolean).join(' · '));
        var remove = document.createElement('button');
        remove.type = 'button'; remove.textContent = 'Remove';
        remove.setAttribute('aria-label', 'Remove ' + item.title);
        self.listen(remove, 'click', function () { lists[activeList].splice(index, 1); save(activeList); renderList(); dialog.querySelector('[data-equipment-selection-close]').focus(); });
        heading.appendChild(remove);
      });
      var body = table.createTBody();
      var keys = isQuote ? ['Quantity', 'SKU', 'Requested options'] : Array.from(new Set(items.flatMap(function (item) { return item.specs.map(function (spec) { return spec.key; }); })));
      keys.forEach(function (key) {
        var label = isQuote ? key : items.flatMap(function (item) { return item.specs; }).find(function (spec) { return spec.key === key; }).label;
        var row = body.insertRow();cell(row, 'th', label).scope = 'row';
        items.forEach(function (item) {
          var value;
          if (isQuote) value = key === 'Quantity' ? item.quantity : key === 'SKU' ? item.sku : item.options.map(function (pair) { return pair.join(': '); }).join('; ');
          else { var spec = item.specs.find(function (spec) { return spec.key === key; }); value = spec ? spec.value + (spec.note ? ' (' + spec.note + ')' : '') : '—'; }
          cell(row, 'td', value);
        });
      });
      if (items.length) content.appendChild(table);
      else content.textContent = 'Your list is empty.';
      var link = dialog.querySelector('[data-equipment-selection-quote]');
      link.hidden = !isQuote || !items.length;
      var url = new URL(form.getAttribute('data-quote-url') || form.action, window.location.origin);
      url.searchParams.set('view', 'request-quote');
      url.searchParams.set('equipment_items', JSON.stringify(items.map(function (item) { return { productId: item.productId, variantId: item.variantId, title: item.title, sku: item.sku, url: item.url, quantity: item.quantity, options: item.options }; })));
      link.href = url.pathname + url.search;
    };
    this.root.querySelectorAll('[data-equipment-save]').forEach(function (button) {
      self.listen(button, 'click', function () {
        activeList = button.getAttribute('data-equipment-save');
        var item = snapshot();
        // Both lists distinguish the selected native variant and resolved configuration.
        var matching = lists[activeList].findIndex(function (saved) { return (saved.key ? saved.key === item.key : saved.url === item.url) && JSON.stringify(saved.options) === JSON.stringify(item.options); });
        if (matching < 0) lists[activeList].push(item); else lists[activeList][matching] = item;
        save(activeList);renderList();returnFocus = button;dialog.showModal();
        dialog.querySelector('[data-equipment-selection-close]').focus();
      });
    });
    this.listen(dialog.querySelector('[data-equipment-selection-close]'), 'click', function () { dialog.close(); });
    this.listen(dialog, 'click', function (event) {
      if (event.target !== dialog) return;
      var bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
    this.listen(dialog, 'close', function () { if (returnFocus && returnFocus.isConnected) returnFocus.focus({ preventScroll: true }); });
    this.selectionDialog = dialog;
  };

  ProductPage.prototype.syncViewer = function (imageId) {
    if (!this.viewer || !imageId) return;
    var thumb = this.viewer.querySelector('[data-product-image-viewer-thumb][data-image-id="' + imageId + '"]');
    var image = this.viewer.querySelector('[data-product-image-viewer-image]');
    if (!thumb || !image) return;
    image.src = thumb.getAttribute('data-image-src');
    image.alt = thumb.getAttribute('data-image-alt') || '';
    this.viewer.querySelectorAll('[data-product-image-viewer-thumb]').forEach(function (item) {
      var active = item === thumb;
      item.classList.toggle('is-active', active);
      if (active) item.setAttribute('aria-current', 'true');
      else item.removeAttribute('aria-current');
    });
    if (this.viewerOpen && thumb.scrollIntoView) thumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
  };

  ProductPage.prototype.lockViewerScroll = function () {
    this.previousBodyOverflow = document.body.style.overflow;
    this.previousBodyPaddingRight = document.body.style.paddingRight;
    var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    if (scrollbarWidth > 0) document.body.style.paddingRight = scrollbarWidth + 'px';
    document.body.style.overflow = 'hidden';
    document.body.classList.add('product-image-viewer-open');
  };

  ProductPage.prototype.unlockViewerScroll = function () {
    document.body.classList.remove('product-image-viewer-open');
    document.body.style.overflow = this.previousBodyOverflow;
    document.body.style.paddingRight = this.previousBodyPaddingRight;
  };

  ProductPage.prototype.openViewer = function (trigger) {
    if (!this.viewer) return;
    this.viewerReturnFocus = trigger;
    this.syncViewer(trigger.getAttribute('data-image-id') || this.activeImageId());
    this.viewer.hidden = false;
    this.viewerOpen = true;
    this.lockViewerScroll();
    var close = this.viewer.querySelector('[data-product-image-viewer-close]');
    window.requestAnimationFrame(function () {
      if (close) close.focus({ preventScroll: true });
    });
  };

  ProductPage.prototype.closeViewer = function (restoreFocus) {
    if (!this.viewer || !this.viewerOpen) return;
    this.viewer.hidden = true;
    this.viewerOpen = false;
    this.unlockViewerScroll();
    if (restoreFocus !== false && this.viewerReturnFocus && document.documentElement.contains(this.viewerReturnFocus)) {
      this.viewerReturnFocus.focus({ preventScroll: true });
    }
    this.viewerReturnFocus = null;
  };

  ProductPage.prototype.viewerFocusable = function () {
    if (!this.viewer) return [];
    return Array.prototype.filter.call(
      this.viewer.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'),
      function (element) { return !element.hidden && element.offsetParent !== null; }
    );
  };

  ProductPage.prototype.initViewer = function () {
    var self = this;
    this.viewer = this.root.querySelector('[data-product-image-viewer]');
    var expand = this.root.querySelector('[data-product-image-expand]');
    if (!this.viewer || !expand) return;

    this.listen(expand, 'click', function () { self.openViewer(expand); });
    this.listen(this.viewer, 'click', function (event) {
      if (event.target.closest('[data-product-image-viewer-close]')) {
        self.closeViewer(true);
        return;
      }
      if (event.target === self.viewer.querySelector('[data-product-image-viewer-backdrop]')) {
        self.closeViewer(true);
        return;
      }
      var thumb = event.target.closest('[data-product-image-viewer-thumb]');
      if (!thumb) return;
      var imageId = String(thumb.getAttribute('data-image-id'));
      self.syncViewer(imageId);
      var galleryThumb = self.root.querySelector('.product-photo-thumb[data-image-id="' + imageId + '"]');
      if (galleryThumb) galleryThumb.click();
    });

    this.listen(document, 'keydown', function (event) {
      if (!self.viewerOpen) return;
      if (event.key === 'Escape' || event.key === 'Esc') {
        event.preventDefault();
        self.closeViewer(true);
        return;
      }
      if (event.key !== 'Tab') return;
      var focusable = self.viewerFocusable();
      var dialog = self.viewer.querySelector('[data-product-image-viewer-dialog]');
      if (!focusable.length) {
        event.preventDefault();
        dialog.focus();
        return;
      }
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    this.listen(document, 'focusin', function (event) {
      if (!self.viewerOpen) return;
      var dialog = self.viewer.querySelector('[data-product-image-viewer-dialog]');
      if (dialog.contains(event.target)) return;
      var focusable = self.viewerFocusable();
      (focusable[0] || dialog).focus({ preventScroll: true });
    });
  };

  ProductPage.prototype.destroy = function () {
    if (this.resetHoverZoom) this.resetHoverZoom();
    if (this.hoverZoom) this.hoverZoom.remove();
    this.closeViewer(false);
    if (this.reviewDialog && this.reviewDialog.open) this.reviewDialog.close();
    if (this.selectionDialog && this.selectionDialog.open) this.selectionDialog.close();
    this.abortController.abort();
    if (this.carousels) this.carousels.forEach(function (carousel) { carousel.destroy(); });
    if (this.resizeFrame) window.cancelAnimationFrame(this.resizeFrame);
    if (this.scrollFrame) window.cancelAnimationFrame(this.scrollFrame);
    this.root._ersProductPage = null;
  };

  function initialize(scope) {
    var roots = [];
    if (scope && scope.matches && scope.matches('[data-product-page-enhancements]')) roots.push(scope);
    if (scope && scope.querySelectorAll) {
      roots = roots.concat(Array.prototype.slice.call(scope.querySelectorAll('[data-product-page-enhancements]')));
    }
    roots.forEach(function (root) {
      if (root._ersProductPage) return;
      var instance = new ProductPage(root);
      instances.push(instance);
    });

    var recommendationRoots = [];
    if (scope && scope.matches && scope.matches('[data-product-recommendations]')) recommendationRoots.push(scope);
    if (scope && scope.querySelectorAll) {
      recommendationRoots = recommendationRoots.concat(Array.prototype.slice.call(scope.querySelectorAll('[data-product-recommendations]')));
    }
    recommendationRoots.forEach(function (root) {
      if (root._ersProductRecommendations) return;
      recommendationInstances.push(new ProductRecommendations(root));
    });
  }

  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    instances = instances.filter(function (instance) {
      if (event.target.contains(instance.root) || event.target === instance.root) {
        instance.destroy();
        return false;
      }
      return true;
    });
    recommendationInstances = recommendationInstances.filter(function (instance) {
      if (event.target.contains(instance.root) || event.target === instance.root) {
        instance.destroy();
        return false;
      }
      return true;
    });
  });

  window.ERSProductPageEnhancements = { initialize: initialize };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialize(document); }, { once: true });
  } else {
    initialize(document);
  }
})();
